import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(VIcon,{on:{"click":function($event){return _vm.setDialog(true)}}},[_vm._v(" "+_vm._s(_vm.icons.mdiPalette)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }